const ExhibitionWork = ({ reportData = false } = {}) => `
  artworkCat
  exhibited
  exhibitionId
  id
  instance {
    id
    artistNames
    bondType { type, company }
    edition {
      artwork {
        artworkCategory {
          name
        }
        dimensions
        imagesSummary {
          imgT
        }
        medium
        series
        title
      }
      number
      year
    }
    editionNumber
    name
    ref
    ${reportData
        ? `
      company {
        id
        name
        code
        contact {
          forename
          name
          surname
        }
      }
      description
      status {
        name
      }
      value {
        currency {
          code
        }
        value
      }
      primaryWarehouseItem {
        id
        description
        dimd
        dimw
        dimh
        itemSite {
          location {
            id
            description
          }
          site {
            id
            name
            description
          }
        }
        packing {
          id
          description
          updatedAt
        }
        weight
      }
      weight

    `
        : ""
    }
  }
  instanceId
  notes
  ${
    reportData
      ? `
      offer {
        id
        contact {
          forename
          surname
          name
        }
        contactId
        hold {
          name
          ref
          description
          notes
        }
        holdId
        holdDate
        status {
          description
        }
        statusId
        user
      }
    `
      : ""
  }
  removed
  technicalNotes
  updatedAt
  user
`;

export default ExhibitionWork;
